import Flickity from 'flickity';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import createStore from '../configs/create-store-with-generators.js';

import * as CardReducer from '../modules/card/card.reducers.js';
import * as URLReducer from '../modules/url/url.reducers.js';
import * as BreadcrumbsReducer from '../modules/breadcrumbs/breadcrumbs.reducers.js';
import { user } from '../modules/user/user.reducers.js';
import * as UIReducer from '../modules/ui/ui.reducers.js';

import ErrorHandler from '../modules/error/error-handler.screen.js';
import IndexScreen from '../modules/landing-page/index.screen.js';

const initialState = window.serverData.initialState;

const store = createStore(initialState, {
  user,
  ...CardReducer,
  ...BreadcrumbsReducer,
  ...UIReducer,
  ...URLReducer
});
const wrappedApp = (
  <Provider store={store}>
    <ErrorHandler>
      <IndexScreen/>
    </ErrorHandler>
  </Provider>
);

const rootEl = document.getElementById('js--index');
if (rootEl) {
  rootEl.innerHTML = '';
  const root = createRoot(rootEl);
  root.render(wrappedApp);
}

window.addEventListener('load', function() {
  const itemsSlider = document.querySelector('.js--index-info-icons-items');
  const indexManagementSlider = document.querySelector('.js--index-management-slider');
  const indexScrinsSliderApp = document.querySelector('.js--index-screens-slider-app');
  const indexScrinsSliderWeb = document.querySelector('.js--index-screens-slider-web');
  const indexAllIncludeItems = document.querySelector('.js--index-all-include-items');
  const indexBlogNewsItems = document.querySelector('.js--index-blog-news');

  const indexMoreNewsInput = document.querySelector('.js--index-more-news-input');
  const indexMoreNewsLabel = document.querySelector('.js--index-more-news-label');
  const indexDemoVideoBtn = document.querySelector('.js--index-demo-video-btn');
  const indexVideoIframe = document.querySelector('.js--index-video-iframe');
  const indexVideoPopupLabel = document.querySelectorAll('.js--index-video-popup-label');
  const indeVideoPopupInput = document.getElementById('index-video-popup-input');

  let allIncludeItems;
  let itemsSliderFlickity;

  const flickityDefaultOptions = {
    cellAlign: 'center',
    imagesLoaded: true,
    percentPosition: true,
    dragThreshold: 50,
    draggable: true,
    pageDots: true,
    wrapAround: true
  };

  const processSliders = () => {
    if (window.innerWidth < 769) {
      if (indexAllIncludeItems) {
        allIncludeItems = new Flickity(indexAllIncludeItems, flickityDefaultOptions);
      }
      if (itemsSlider) {
        itemsSliderFlickity = new Flickity(itemsSlider, flickityDefaultOptions);
      }
    } else {
      if (indexAllIncludeItems && allIncludeItems && allIncludeItems.constructor.name === 'Flickity') {
        allIncludeItems.destroy();
      }
      if (itemsSlider && itemsSliderFlickity && itemsSliderFlickity.constructor.name === 'Flickity') {
        itemsSliderFlickity.destroy();
      }
    }
  };

  processSliders();
  addEventListener("resize", processSliders);

  // Initialize remaining Flickity sliders
  if (document.documentElement.clientWidth < 769) {
    if (indexMoreNewsInput) {
      indexMoreNewsInput.remove();
    }
    
    if (indexMoreNewsLabel) {
      indexMoreNewsLabel.remove();
    }
    
    if (indexBlogNewsItems) {
      new Flickity(indexBlogNewsItems, {
        cellAlign: 'center',
        imagesLoaded: true,
        percentPosition: true,
        dragThreshold: 50,
        draggable: true,
        pageDots: true,
        contain: true
      });
    }
  }

  if (indexManagementSlider) {
    new Flickity(indexManagementSlider, {
      cellAlign: 'center',
      contain: true,
      imagesLoaded: true,
      percentPosition: true,
      dragThreshold: 50,
      draggable: true,
      pageDots: true
    });
  }

  let oneClickWebBtn = true;
  const indexScreensWebToggle = document.querySelector('.index-screens-toggler-web');
  indexScreensWebToggle && indexScreensWebToggle.addEventListener('click', () => {
    if (oneClickWebBtn) {
      oneClickWebBtn = false;
      if (indexScrinsSliderWeb) {
        new Flickity(indexScrinsSliderWeb, {
          cellAlign: 'center',
          contain: true,
          lazyLoad: true,
          imagesLoaded: true,
          percentPosition: true,
          dragThreshold: 50,
          draggable: true
        });
      }
    }
  });

  if (indexScrinsSliderApp) {
    new Flickity(indexScrinsSliderApp, {
      cellAlign: 'center',
      lazyLoad: 2,
      contain: true,
      imagesLoaded: true,
      percentPosition: true,
      dragThreshold: 50,
      draggable: true
    });
  }

  if (indexDemoVideoBtn && indexVideoIframe && indexVideoPopupLabel && indeVideoPopupInput) {
    indexDemoVideoBtn.addEventListener('click', function() {
      indexVideoIframe.setAttribute('src', 'https://www.youtube.com/embed/iO_8rNiA1o0?autoplay=1');
      indeVideoPopupInput.checked = true;
    });

    [].forEach.call(indexVideoPopupLabel, el => {
      el.addEventListener('click', function() {
        indexVideoIframe.setAttribute('src', '');
      });
    });
  }
});

require(['jquery', 'fotorama/fotorama.js'], $ => {
  if (!$('html').hasClass('touch')) {
    $('.fotorama').attr('data-swipe', 'false');
  }

  $('#searchForm').submit(event => {
    event.preventDefault();

    var searchForm = $(document.searchForm).serializeArray(),
      link = '';
    for (var i = 0; i < searchForm.length; i++) {
      if (searchForm[i].value.length > 0 && searchForm[i].value !== 'false') {
        link = link + searchForm[i].name + '=' + searchForm[i].value + ';';
      }
    }
    link = link + '/';
    location = location.origin + '/organizations/find/' + link;
  });

  $('#js--advanced-search').click(function(event) {
    event.preventDefault();
    $('input[name="advanced"]').attr('value', true);
    $('#searchForm').submit();
  });
});
